import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './i18n/LanguageContext';
import { MotherProvider } from './lib/MotherContext';
import Layout from './components/Layout';
import { Toaster } from 'sonner';
import ConsentBanner from './components/ConsentBanner';

import Landing from './pages/Landing';
import LanguageSelect from './pages/LanguageSelect';
import SelfCheck from './pages/SelfCheck';
import Result from './pages/Result';
import Teaching from './pages/Teaching';
import WhatsAppSummary from './pages/WhatsAppSummary';
import Booking from './pages/Booking';
import Consultants from './pages/Consultants';
import MilkLog from './pages/MilkLog';
import Admin from './pages/Admin';
import Library from './pages/Library';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ProfileStart from './pages/ProfileStart';
import ProfileLogin from './pages/ProfileLogin';
import ForgotPin from './pages/ForgotPin';
import MyProfile from './pages/MyProfile';

function LangGate({ children }) {
  const { rawLang } = useLanguage();
  if (!rawLang) return <Navigate to="/language" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/language" element={<LanguageSelect />} />
      <Route
        path="/"
        element={<LangGate><Layout><Landing /></Layout></LangGate>}
      />
      <Route path="/self-check" element={<LangGate><Layout><SelfCheck /></Layout></LangGate>} />
      <Route path="/result" element={<LangGate><Layout><Result /></Layout></LangGate>} />
      <Route path="/teaching/:id?" element={<LangGate><Layout><Teaching /></Layout></LangGate>} />
      <Route path="/whatsapp-summary" element={<LangGate><Layout><WhatsAppSummary /></Layout></LangGate>} />
      <Route path="/booking" element={<LangGate><Layout><Booking /></Layout></LangGate>} />
      <Route path="/consultants" element={<LangGate><Layout><Consultants /></Layout></LangGate>} />
      <Route path="/milk-log" element={<LangGate><Layout><MilkLog /></Layout></LangGate>} />
      <Route path="/library" element={<LangGate><Layout><Library /></Layout></LangGate>} />
      <Route path="/about" element={<LangGate><Layout><About /></Layout></LangGate>} />
      <Route path="/privacy" element={<LangGate><Layout><Privacy /></Layout></LangGate>} />
      <Route path="/terms" element={<LangGate><Layout><Terms /></Layout></LangGate>} />
      <Route path="/admin" element={<LangGate><Layout><Admin /></Layout></LangGate>} />
      <Route path="/profile/start" element={<LangGate><Layout><ProfileStart /></Layout></LangGate>} />
      <Route path="/profile/login" element={<LangGate><Layout><ProfileLogin /></Layout></LangGate>} />
      <Route path="/profile/forgot-pin" element={<LangGate><Layout><ForgotPin /></Layout></LangGate>} />
      <Route path="/my" element={<LangGate><Layout><MyProfile /></Layout></LangGate>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <MotherProvider>
            <AppRoutes />
            <ConsentBanner />
            <Toaster position="top-center" richColors />
          </MotherProvider>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
